// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__1S_4j","obliqueLineWrap":"membershipbadge_obliqueLineWrap__1rB3q","obliqueLine":"membershipbadge_obliqueLine__1g1xa"};